var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_4223)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_26_4223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.87 1H5.69C5.07697 1 4.58 1.49696 4.58 2.11V16.87C4.58 17.483 5.07697 17.98 5.69 17.98H21.87C22.483 17.98 22.98 17.483 22.98 16.87V2.11C22.98 1.49696 22.483 1 21.87 1Z",
    fill: "#5E7DA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.48 3.39001H3.3C2.68697 3.39001 2.19 3.88698 2.19 4.50001V19.26C2.19 19.8731 2.68697 20.37 3.3 20.37H19.48C20.093 20.37 20.59 19.8731 20.59 19.26V4.50001C20.59 3.88698 20.093 3.39001 19.48 3.39001Z",
    fill: "#82ACE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.29 5.57996H1.11C0.496964 5.57996 0 6.07692 0 6.68996V21.45C0 22.063 0.496964 22.56 1.11 22.56H17.29C17.903 22.56 18.4 22.063 18.4 21.45V6.68996C18.4 6.07692 17.903 5.57996 17.29 5.57996Z",
    fill: "#CCDBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9 5.57996H17.5C18 5.57996 18.4 5.97996 18.4 6.47996V10.26H0V6.47996C0 5.97996 0.4 5.57996 0.9 5.57996Z",
    fill: "#526273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19 6.96997H2.19V9.48997H6.19V6.96997Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39999 7.81995H8.39999V8.63995H9.39999V7.81995Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.48 7.81995H10.48V8.63995H11.48V7.81995Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.57 7.81995H12.57V8.63995H13.57V7.81995Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.66 7.81995H14.66V8.63995H15.66V7.81995Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.74 7.81995H16.74V8.63995H17.74V7.81995Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52 11.88H1.87V20.64H6.52V11.88Z",
    fill: "#7D95B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.37 11.88H8V13.72H16.37V11.88Z",
    fill: "#7D95B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.37 18.8H8V20.64H16.37V18.8Z",
    fill: "#7D95B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.37 15.34H8V17.18H16.37V15.34Z",
    fill: "#7D95B0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_4223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_26_4223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.98,
    height: 21.56,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.8a0c18ec1686b8e05a8bf97e6d4b36fc.svg";
export { ForwardRef as ReactComponent };